import { useCallback } from 'react';

import type { UpdateInvestorFirmEmployeeInput } from '../../../../../../../../graphql';
import {
  useInvestorFirms_AdminUpdateContactMutation,
  useInvestorFirms_UpdateContactMutation,
} from '../graphql/__generated__';

type UpdateInvestorFirmEmployeeVariables = {
  employeeKeyOrId: string;
  firmKeyOrId: string;
  input: UpdateInvestorFirmEmployeeInput;
};

export function useUpdateContact(tenantId?: string) {
  const [updateContactAsCustomer, { error: updateContactErrorAsCustomer }] =
    useInvestorFirms_UpdateContactMutation();
  const [updateContactAsAdmin, { error: updateContactErrorAsAdmin }] =
    useInvestorFirms_AdminUpdateContactMutation();

  const updateContact = useCallback(
    async (variables: UpdateInvestorFirmEmployeeVariables) => {
      if (tenantId) {
        await updateContactAsAdmin({
          variables: {
            input: {
              ...variables,
              tenantId,
            },
          },
        });
      } else {
        await updateContactAsCustomer({
          variables,
        });
      }
    },
    [tenantId, updateContactAsCustomer, updateContactAsAdmin]
  );
  return {
    updateContact,
    error: updateContactErrorAsCustomer || updateContactErrorAsAdmin,
  };
}
